module.exports = __webpack_public_path__ + "static/media/l_itdot_17.08e22087.png";